<template>
  <!-- 菜单栏 -->
  <el-menu
    class="el-menu-vertical"
    :default-active="$route.path"
    background-color="#2d3a4b"
    text-color="rgb(191, 203, 217)"
    active-text-color="#409EFF"
    @select="handleselect"
    :unique-opened="true"
    :collapse="isCollapse"
  >
    <div class="head_name">
      <!-- <img src="@/assets/logo.png" alt="" /> -->
      <span v-show="!isCollapse">成旅聘通人才库</span>
    </div>
    <template v-for="item in menus">
      <!-- 多级目录 -->
      <el-submenu
        v-if="item.children && item.children.length > 0"
        :index="item.path"
        :key="item.path"
        class="menu-fontsize"
      >
        <template slot="title">
          <i :class="item.meta.icon" v-if="item.meta"></i>
          <span>{{ item.name }}</span>
        </template>
        <el-menu-item
          v-for="child in item.children"
          :key="child.path"
          :index="child.path"
          class="menu-fontsize"
        >
          <span slot="title">{{ child.name }}</span>
        </el-menu-item>
      </el-submenu>
      <!-- 一级目录 -->
      <el-menu-item
        v-else
        :key="item.path"
        :index="item.alias || item.path"
        class="menu-fontsize"
      >
        <i :class="item.meta.icon" v-if="item.meta"></i>
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import routes from "../../router/menuRoutes";
export default {
  data() {
    return {
      menus: [],
    };
  },
  props: ["isCollapse"],
  created() {
    // const loginInfo = JSON.parse(localStorage.getItem("loginUser"));
    this.menus = routes.children.filter((ele) => {
      /**
       * 可在此处进行鉴权判断
       * 筛选需要展示的数据
       */
      if (ele.children) {
        ele.children = ele.children.filter((child) => {
          return child.meta.hidden != true;
        });
      }
      return ele.meta.hidden != true;
    });
  },
  mounted() {},
  methods: {
    //选择菜单栏
    handleselect(index) {
      if (this.$route.fullPath !== index) {
        this.$router.push(index);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.el-menu-item {
  font-size: 14px;

  &:hover {
    i {
      margin-left: 5px;
    }
  }

  i {
    transition: all 0.5s;
  }
}
.head_name {
  height: 60px;
  letter-spacing: 1px;
  color: #333;
  // background-color: #fff;
  font-size: 18px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 40px;
  }
  span {
    white-space: nowrap;
    margin-left: 10px;
    color: #fff;
  }
}
.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  flex-shrink: 0;
}
</style>
